export enum PostingType {
  TempShift = 'TEMP_SHIFT',
  OnsiteInterview = 'ONSITE_INTERVIEW',
}
